// =============================================================================
// MHV Live Player — OvenPlayer WebRTC with custom controls + reconnection
// Extracted from snippets/live-player.liquid
//
// Reads config from data attributes on #whep-player-container:
//   data-stream-url, data-autostart, data-start-muted, data-mute-reminder,
//   data-mute-reminder-delay, data-mute-reminder-duration, data-mute-reminder-interval
// =============================================================================

(function() {
  'use strict';

  // ========================================
  // Config from data attributes
  // ========================================
  var container = document.getElementById('whep-player-container');
  if (!container) return;

  var playerConfig = {
    streamUrl: container.dataset.streamUrl || '',
    autostart: container.dataset.autostart === 'true',
    startMuted: container.dataset.startMuted === 'true',
    muteReminder: container.dataset.muteReminder === 'true',
    muteReminderDelay: parseInt(container.dataset.muteReminderDelay) || 30000,
    muteReminderDuration: parseInt(container.dataset.muteReminderDuration) || 30000,
    muteReminderInterval: parseInt(container.dataset.muteReminderInterval) || 120000
  };

  // ========================================
  // Global State
  // ========================================
  window.mhvMuteState = playerConfig.startMuted;
  window.mhvPlayState = false;

  // ========================================
  // Control Functions
  // ========================================

  // Toggle mute/unmute function
  function toggleMute(event) {
    // Slideshow/audio (Control Room) mode: the audio-only mixer stream carries the
    // sound and the video player is hidden — route the single mute button to it so
    // one button + one icon works in BOTH modes.
    if (window.MHVLiveAudio && window.MHVLiveAudio.mode === 'audio') {
      window.MHVLiveAudio.toggleMute();
      return;
    }

    var isFirstInteraction = !window.__mhvUserGesturePlayDone;

    if (isFirstInteraction) {
      window.__mhvUserGesturePlayDone = true;
      window.userHasInteracted = true;
    }

    if (!window._mhvPlayer) return;

    try {
      if (isFirstInteraction && window.mhvMuteState) {
        if (typeof window._mhvPlayer.setMute === 'function') {
          window._mhvPlayer.setMute(false);
        } else if (typeof window._mhvPlayer.unmute === 'function') {
          window._mhvPlayer.unmute();
        }
        window.mhvMuteState = false;
        updateMuteButtonUI(false);
        return;
      }

      if (window.mhvMuteState) {
        if (typeof window._mhvPlayer.setMute === 'function') {
          window._mhvPlayer.setMute(false);
        } else if (typeof window._mhvPlayer.unmute === 'function') {
          window._mhvPlayer.unmute();
        }
        window.mhvMuteState = false;
        updateMuteButtonUI(false);
      } else {
        if (typeof window._mhvPlayer.setMute === 'function') {
          window._mhvPlayer.setMute(true);
        } else if (typeof window._mhvPlayer.mute === 'function') {
          window._mhvPlayer.mute();
        }
        window.mhvMuteState = true;
        updateMuteButtonUI(true);
      }
    } catch (error) {
      // Silent fail
    }
  }

  // Play function (no pause for live streams)
  function togglePlayPause(event) {
    if (!window.__mhvUserGesturePlayDone) {
      window.__mhvUserGesturePlayDone = true;
      window.userHasInteracted = true;
    }

    if (!window._mhvPlayer) return;

    try {
      if (!window.mhvPlayState) {
        if (typeof window._mhvPlayer.play === 'function') {
          window._mhvPlayer.play();
        }
        window.mhvPlayState = true;
        updatePlayPauseButtonUI(true);
      }
    } catch (error) {
      // Silent fail
    }
  }

  // Update button UI based on mute state
  function updateMuteButtonUI(isMuted) {
    // In slideshow/audio mode the audio mixer owns the mute icon (it reflects the
    // audio stream, not the intentionally-muted video) — don't let video events clobber it.
    if (window.MHVLiveAudio && window.MHVLiveAudio.mode === 'audio') return;
    var muteIcon = document.getElementById('mute-icon');
    if (muteIcon) {
      if (isMuted) {
        muteIcon.src = 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/mute.png?v=1754371518';
        muteIcon.alt = 'Unmute';
      } else {
        muteIcon.src = 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/audio-on.png?v=1754371513';
        muteIcon.alt = 'Mute';
        if (typeof stopMuteReminderGlow === 'function') {
          stopMuteReminderGlow();
        }
      }
    }
  }
  window.updateMuteButtonUI = updateMuteButtonUI;

  // Update button UI based on play state
  function updatePlayPauseButtonUI(isPlaying) {
    var playPauseBtn = document.getElementById('play-pause-btn');
    var playPauseIcon = document.getElementById('play-pause-icon');

    if (playPauseBtn && playPauseIcon) {
      if (isPlaying) {
        playPauseBtn.style.display = 'none';
      } else {
        playPauseBtn.style.display = 'block';
        playPauseIcon.src = 'https://cdn.shopify.com/s/files/1/0073/9101/9067/files/play.png?v=1755746359';
        playPauseIcon.alt = 'Play';
      }
    }
  }
  window.updatePlayPauseButtonUI = updatePlayPauseButtonUI;

  // ========================================
  // Mute Reminder Glow
  // ========================================
  var muteReminderInterval = null;
  var muteGlowTimeout = null;

  function startMuteGlow() {
    var muteBtn = document.getElementById('mute-toggle-btn');
    if (!muteBtn || !window.mhvMuteState) return;

    muteBtn.classList.add('glowing');

    muteGlowTimeout = setTimeout(function() {
      muteBtn.classList.remove('glowing');
    }, playerConfig.muteReminderDuration);
  }

  function stopMuteReminderGlow() {
    var muteBtn = document.getElementById('mute-toggle-btn');
    if (muteBtn) {
      muteBtn.classList.remove('glowing');
    }
    if (muteReminderInterval) {
      clearInterval(muteReminderInterval);
      muteReminderInterval = null;
    }
    if (muteGlowTimeout) {
      clearTimeout(muteGlowTimeout);
      muteGlowTimeout = null;
    }
  }
  window.stopMuteReminderGlow = stopMuteReminderGlow;

  function initMuteReminderGlow() {
    setTimeout(function() {
      if (window.mhvMuteState) {
        startMuteGlow();

        muteReminderInterval = setInterval(function() {
          if (window.mhvMuteState) {
            startMuteGlow();
          } else {
            stopMuteReminderGlow();
          }
        }, playerConfig.muteReminderInterval);
      }
    }, playerConfig.muteReminderDelay);
  }

  // ========================================
  // Reconnection System
  // ========================================

  window.mhvReconnectState = {
    isReconnecting: false,
    attemptCount: 0,
    maxAttempts: 5,
    retryDelay: 3000,
    reconnectTimeout: null,
    healthCheckInterval: null,
    frameCaptureInterval: null,
    lastVideoTime: 0,
    stallCount: 0,
    hasValidFrame: false
  };

  // ⚠️ PERFORMANCE (2026-11-02): this ran every 500 ms on every viewer's phone and
  // re-set canvas.width/height each time — which reallocates and clears the whole
  // bitmap (~8 MB at 1080p) twice a second for a picture that is only ever SHOWN
  // when the stream drops. Now the canvas is resized only when the video's size
  // changes, the capture runs every 2 s (FRAME_CAPTURE_MS), it skips a hidden tab,
  // and handlePlayerError takes one last capture before it shows the frame.
  var FRAME_CAPTURE_MS = 2000;
  function captureFrozenFrame() {
    var video = document.querySelector('#mhv-webrtc-player video');
    var canvas = document.getElementById('player-frozen-frame');

    if (video && canvas && video.readyState >= 2 && !video.paused && video.videoWidth > 0) {
      try {
        if (canvas.width !== video.videoWidth) canvas.width = video.videoWidth;
        if (canvas.height !== video.videoHeight) canvas.height = video.videoHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        window.mhvReconnectState.hasValidFrame = true;
        return true;
      } catch (e) {
        // Silent fail for continuous capture
      }
    }
    return false;
  }

  function showFrozenFrame() {
    var canvas = document.getElementById('player-frozen-frame');
    if (canvas && window.mhvReconnectState.hasValidFrame) {
      canvas.style.display = 'block';
    }
  }

  function hideFrozenFrame() {
    var canvas = document.getElementById('player-frozen-frame');
    if (canvas) {
      canvas.style.display = 'none';
    }
  }

  function startFrameCapture() {
    var state = window.mhvReconnectState;
    if (state.frameCaptureInterval) {
      clearInterval(state.frameCaptureInterval);
    }
    state.frameCaptureInterval = setInterval(function() {
      if (document.hidden) return;
      if (window.mhvPlayState && !state.isReconnecting) {
        captureFrozenFrame();
      }
    }, FRAME_CAPTURE_MS);
  }

  function stopFrameCapture() {
    var state = window.mhvReconnectState;
    if (state.frameCaptureInterval) {
      clearInterval(state.frameCaptureInterval);
      state.frameCaptureInterval = null;
    }
  }

  function showReconnectOverlay() {
    var overlay = document.getElementById('player-reconnect-overlay');
    var spinner = document.getElementById('reconnect-spinner');
    var reloadBtn = document.getElementById('reconnect-reload-btn');
    var resumeBtn = document.getElementById('reconnect-resume-btn');

    if (overlay) {
      overlay.classList.remove('hidden');
      if (spinner) spinner.style.display = 'block';
      if (reloadBtn) reloadBtn.style.display = 'none';
      if (resumeBtn) resumeBtn.style.display = 'none';
    }
  }

  function showResumeButton() {
    var overlay = document.getElementById('player-reconnect-overlay');
    var spinner = document.getElementById('reconnect-spinner');
    var reloadBtn = document.getElementById('reconnect-reload-btn');
    var resumeBtn = document.getElementById('reconnect-resume-btn');

    if (overlay) {
      overlay.classList.remove('hidden');
      if (spinner) spinner.style.display = 'none';
      if (reloadBtn) reloadBtn.style.display = 'none';
      if (resumeBtn) resumeBtn.style.display = 'flex';
    }
  }

  function showReloadButton() {
    var overlay = document.getElementById('player-reconnect-overlay');
    var spinner = document.getElementById('reconnect-spinner');
    var reloadBtn = document.getElementById('reconnect-reload-btn');

    if (overlay) {
      overlay.classList.remove('hidden');
      if (spinner) spinner.style.display = 'none';
      if (reloadBtn) reloadBtn.style.display = 'block';
    }
  }

  function hideReconnectOverlay() {
    var overlay = document.getElementById('player-reconnect-overlay');
    if (overlay) {
      overlay.classList.add('hidden');
    }
    hideFrozenFrame();
    window.mhvReconnectState.attemptCount = 0;
    window.mhvReconnectState.isReconnecting = false;
    window.mhvReconnectState.stallCount = 0;
    window.mhvReconnectState.hasValidFrame = false;
  }

  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  function attemptReconnect() {
    var state = window.mhvReconnectState;

    if (state.reconnectTimeout) {
      clearTimeout(state.reconnectTimeout);
      state.reconnectTimeout = null;
    }

    state.attemptCount++;

    if (state.attemptCount > state.maxAttempts) {
      showReloadButton();
      state.isReconnecting = false;
      return;
    }

    var needsFullRecreation = isIOS();

    if (!needsFullRecreation && window._mhvPlayer && typeof window._mhvPlayer.load === 'function') {
      try {
        window._mhvPlayer.load([{
          type: 'webrtc',
          file: playerConfig.streamUrl
        }]);

        setTimeout(function() {
          if (window._mhvPlayer) {
            if (typeof window._mhvPlayer.play === 'function') {
              window._mhvPlayer.play();
            }
            setTimeout(function() {
              if (window._mhvPlayer) {
                try {
                  window._mhvPlayer.setMute(false);
                  window.mhvMuteState = false;
                  updateMuteButtonUI(false);
                } catch (e) {
                  // Silent fail
                }
              }
            }, 500);
          }
        }, 500);

        state.reconnectTimeout = setTimeout(function() {
          var overlay = document.getElementById('player-reconnect-overlay');
          if (overlay && !overlay.classList.contains('hidden')) {
            attemptReconnect();
          }
        }, state.retryDelay);

        return;
      } catch (e) {
        // Fall through to full recreation
      }
    }

    // Full player recreation (required for iOS, fallback for others)
    if (window._mhvPlayer) {
      try {
        window._mhvPlayer.remove();
        window._mhvPlayer = null;
      } catch (e) {
        // Silent fail
      }
    }

    var playerContainer = document.getElementById('mhv-webrtc-player');
    if (playerContainer) {
      playerContainer.innerHTML = '';
    }

    setTimeout(function() {
      createMHVPlayer();

      if (needsFullRecreation) {
        setTimeout(function() {
          if (window._mhvPlayer) {
            try {
              window._mhvPlayer.setMute(true);
              window.mhvMuteState = true;
              updateMuteButtonUI(true);
              if (typeof window._mhvPlayer.play === 'function') {
                window._mhvPlayer.play();
              }
            } catch (e) {
              // Silent fail
            }
          }
        }, 1000);
      }

      state.reconnectTimeout = setTimeout(function() {
        var overlay = document.getElementById('player-reconnect-overlay');
        if (overlay && !overlay.classList.contains('hidden')) {
          attemptReconnect();
        }
      }, state.retryDelay);
    }, 500);
  }

  function handlePlayerError(error) {
    var state = window.mhvReconnectState;
    if (state.isReconnecting) return;

    captureFrozenFrame();   // the freshest frame we can still get (a no-op once the video has stopped)
    stopFrameCapture();
    showFrozenFrame();
    state.isReconnecting = true;
    showReconnectOverlay();
    attemptReconnect();
  }

  function startHealthCheck() {
    var state = window.mhvReconnectState;
    if (state.healthCheckInterval) {
      clearInterval(state.healthCheckInterval);
    }

    state.healthCheckInterval = setInterval(function() {
      if (state.isReconnecting) return;

      var video = document.querySelector('#mhv-webrtc-player video');
      if (!video) return;

      if (window.mhvPlayState && video.readyState >= 2) {
        if (video.currentTime === state.lastVideoTime && !video.paused) {
          state.stallCount++;
          if (state.stallCount >= 3) {
            state.stallCount = 0;
            handlePlayerError({ type: 'stall', message: 'Video playback stalled' });
          }
        } else {
          state.stallCount = 0;
        }
        state.lastVideoTime = video.currentTime;
      }
    }, 10000);
  }

  function stopHealthCheck() {
    if (window.mhvReconnectState.healthCheckInterval) {
      clearInterval(window.mhvReconnectState.healthCheckInterval);
      window.mhvReconnectState.healthCheckInterval = null;
    }
  }

  // ========================================
  // OvenPlayer Init
  // ========================================

  function createMHVPlayer() {
    if (!window.OvenPlayer) {
      setTimeout(createMHVPlayer, 500);
      return;
    }

    var el = document.getElementById('mhv-webrtc-player');
    if (!el) return;

    try {
      var player = OvenPlayer.create('mhv-webrtc-player', {
        autoStart: playerConfig.autostart,
        mute: playerConfig.startMuted,
        autoplay: playerConfig.autostart,
        controls: false,
        sources: [{
          type: 'webrtc',
          file: playerConfig.streamUrl
        }],
        webrtcConfig: {
          useTCP: true,
          timeoutMaxRetry: 3,
          connectionTimeout: 5000
        }
      });
      window._mhvPlayer = player;

      player.on('mute', function() {
        window.mhvMuteState = true;
        updateMuteButtonUI(true);
      });

      player.on('unmute', function() {
        window.mhvMuteState = false;
        updateMuteButtonUI(false);
      });

      var isFirstPlay = true;

      player.on('play', function() {
        window.mhvPlayState = true;
        updatePlayPauseButtonUI(true);

        var wasReconnecting = window.mhvReconnectState.isReconnecting;

        hideReconnectOverlay();
        startHealthCheck();
        startFrameCapture();

        if (wasReconnecting && !isIOS()) {
          setTimeout(function() {
            if (window._mhvPlayer) {
              try {
                if (typeof window._mhvPlayer.setMute === 'function') {
                  window._mhvPlayer.setMute(false);
                }
                window.mhvMuteState = false;
                updateMuteButtonUI(false);
              } catch (e) {
                // Silent fail
              }
            }
          }, 500);
        }

        if (wasReconnecting && isIOS() && window.mhvMuteState && !window._projectorPage) {
          var unmuteOnInteraction = function() {
            if (window._mhvPlayer && window.mhvMuteState) {
              try {
                if (typeof window._mhvPlayer.setMute === 'function') {
                  window._mhvPlayer.setMute(false);
                }
                window.mhvMuteState = false;
                updateMuteButtonUI(false);
              } catch (e) {
                // Silent fail
              }
            }
            document.removeEventListener('click', unmuteOnInteraction);
            document.removeEventListener('touchstart', unmuteOnInteraction);
          };
          document.addEventListener('click', unmuteOnInteraction, { once: true });
          document.addEventListener('touchstart', unmuteOnInteraction, { once: true });
        }

        if (isFirstPlay && !window._projectorPage) {
          var unmuteOnFirstInteraction = function(e) {
            var muteBtn = document.getElementById('mute-toggle-btn');
            if (muteBtn && (muteBtn === e.target || muteBtn.contains(e.target))) {
              document.removeEventListener('click', unmuteOnFirstInteraction);
              document.removeEventListener('touchstart', unmuteOnFirstInteraction);
              return;
            }

            if (window._mhvPlayer && window.mhvMuteState) {
              try {
                if (typeof window._mhvPlayer.setMute === 'function') {
                  window._mhvPlayer.setMute(false);
                }
                window.mhvMuteState = false;
                updateMuteButtonUI(false);
              } catch (e) {
                // Silent fail
              }
            }
            document.removeEventListener('click', unmuteOnFirstInteraction);
            document.removeEventListener('touchstart', unmuteOnFirstInteraction);
          };
          document.addEventListener('click', unmuteOnFirstInteraction);
          document.addEventListener('touchstart', unmuteOnFirstInteraction);
        }

        isFirstPlay = false;
      });

      player.on('pause', function() {
        window.mhvPlayState = false;
        updatePlayPauseButtonUI(false);
      });

      player.on('stateChanged', function(newState) {
        if (newState === 'playing') {
          window.mhvPlayState = true;
          updatePlayPauseButtonUI(true);

          var wasReconnecting = window.mhvReconnectState.isReconnecting;
          hideReconnectOverlay();
          startHealthCheck();
          startFrameCapture();

          if (wasReconnecting) {
            setTimeout(function() {
              if (window._mhvPlayer) {
                try {
                  if (typeof window._mhvPlayer.play === 'function') {
                    window._mhvPlayer.play();
                  }
                  if (typeof window._mhvPlayer.setMute === 'function') {
                    window._mhvPlayer.setMute(false);
                  } else if (typeof window._mhvPlayer.unmute === 'function') {
                    window._mhvPlayer.unmute();
                  }
                  window.mhvMuteState = false;
                  updateMuteButtonUI(false);
                } catch (e) {
                  // Silent fail
                }
              }
            }, 500);
          }
        } else if (newState === 'paused' || newState === 'idle') {
          window.mhvPlayState = false;
          updatePlayPauseButtonUI(false);
        } else if (newState === 'error') {
          handlePlayerError({ type: 'state', state: newState });
        }
      });

      player.on('error', function(error) {
        handlePlayerError(error);
      });

      player.on('destroy', function() {
        stopHealthCheck();
      });

      setTimeout(function() {
        try {
          var video = document.querySelector('#mhv-webrtc-player video');
          if (video && video.readyState >= 3) {
            hideReconnectOverlay();
            startHealthCheck();
          }
        } catch (error) {
          // Silent fail
        }
      }, 2000);

    } catch (err) {
      console.error('MHV WebRTC init failed:', err);
      handlePlayerError(err);
    }
  }
  window.createMHVPlayer = createMHVPlayer;

  // Resume button click handler (for mobile autoplay failure)
  function initResumeButton() {
    var resumeBtn = document.getElementById('reconnect-resume-btn');
    if (resumeBtn) {
      resumeBtn.addEventListener('click', function() {
        if (window._mhvPlayer) {
          try {
            window._mhvPlayer.play();
            window._mhvPlayer.setMute(false);
            window.mhvMuteState = false;
            updateMuteButtonUI(false);
            hideReconnectOverlay();
          } catch (e) {
            // Silent fail
          }
        }
      });
    }
  }

  // ========================================
  // Initialization
  // ========================================

  document.addEventListener('DOMContentLoaded', function() {
    updateMuteButtonUI(window.mhvMuteState);
    updatePlayPauseButtonUI(window.mhvPlayState);

    if (playerConfig.muteReminder) {
      initMuteReminderGlow();
    }

    var muteBtn = document.getElementById('mute-toggle-btn');
    var playBtn = document.getElementById('play-pause-btn');

    if (muteBtn) {
      muteBtn.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        toggleMute(event);
      }, true);
    }

    if (playBtn) {
      playBtn.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        togglePlayPause(event);
      }, true);
    }
  });

  // Initial player creation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      createMHVPlayer();
      initResumeButton();
    });
  } else {
    createMHVPlayer();
    initResumeButton();
  }
})();
